import type { ApiSchema } from "./apiSchema";
import { jsonBody, requestJson } from "./http/httpClient";

/**
 * "Report a problem" (F13, FR-VERSION-6): an issue on the installation's DMW project, on the
 * DMW version the server runs. Every signed-in person may report; the account administrators
 * read the reports there (W-08).
 */
export interface IssueReport {
  readonly title: string;
  readonly body: string;
}

export function reportIssue(report: IssueReport): Promise<void> {
  const body: ApiSchema<"ProblemReportBody"> = { title: report.title, body: report.body };
  return requestJson({ method: "POST", path: "/problem-reports", body: jsonBody(body), decodeResponse: () => undefined });
}
